import { render, staticRenderFns } from "./InternetExplorerCheck.vue?vue&type=template&id=42d9c69c&scoped=true&"
import script from "./InternetExplorerCheck.vue?vue&type=script&lang=js&"
export * from "./InternetExplorerCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d9c69c",
  null
  
)

export default component.exports